import React, { Component } from "react";
import AdminBoatListItem from './AdminBoatListItem.js';

class AdminUserListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }

    }
    componentDidMount() {
        // console.log(this.props.user)
    }
    render() {
        let user = this.props.user;
        if (user == 0) {
            user = { _id: 'nouser', username: 'No User' }
        }
        let boats;

        if (typeof this.props.boats == 'object') {
            if (this.props.boats.length == undefined) {
                boats = [this.props.boats];
            } else {
                boats = this.props.boats;
            }
        } else {
            boats = null;
        }

        let boatsList = [];
        if (boats && boats.length > 0) {
            for (let i = 0; i < boats.length; i++) {
                boatsList.push(((<AdminBoatListItem boat={boats[i]} />)))
            }
        }


        return (
            <li key={user._id}>
                <span className='username'>{user.username} - {user._id}</span>
                <ul className='boat'>{boatsList}</ul>

            </li>
        );
    }
}


export default AdminUserListItem;
